import { SignatureRequestToken } from '@app/utils/parseJwt';
import { useState } from 'react';
import { SignatureModal } from './SignatureModal';

export interface SignatureProps {
  jwt: string; // JWT token for authentication
  tokenInfo: SignatureRequestToken;
  disabled?: boolean; // Optional prop to disable the button
}

export function SignatureButton(props: SignatureProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="sticky bottom-0 w-full">
      <button
        className="bg-secondary-500 w-full p-4 disabled:bg-gray-300 disabled:cursor-not-allowed!"
        onClick={() => {
          setIsOpen(true);
        }}
        disabled={props.disabled}
      >
        Jetzt unterschreiben
      </button>
      <SignatureModal {...props} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
}
